import { render, staticRenderFns } from "./crmView.vue?vue&type=template&id=1d833a76&"
import script from "./crmView.vue?vue&type=script&lang=js&"
export * from "./crmView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports